import React, { useState } from 'react'
import styles from './Login.module.scss';
import formStyles from '../../components/common/ui/Form.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { useDispatch } from 'react-redux';
import { login } from '../../module/redux/profile';

const Login = () => {
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [autoLogin, setAutoLogin] = useState(false);

  const [isFetching, setIsFetching] = useState(false);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = (e) => {
    e.preventDefault();

    if (isFetching){
      return;
    }

    setIsFetching(true);
    axios.post('/api/profile/login', {
      email:email,
      password:password,
      autoLogin : autoLogin
    }).then((res) => {
      if (res.data.code === 200){
        dispatch(login(res.data.profile));
        navigate('/');
      }
      else if (res.data.code === 201){
        alert('계정을 찾을 수 없습니다.');
      }
      else if (res.data.code === 202){
        alert('비밀번호가 일치하지 않습니다.');
      }
      else{
        alert(`오류가 발생하였습니다. CODE:${res.data.code}`);
      }

      setIsFetching(false);
    });
  }

  const handleChange = (e) => {
    if (e.target.name === 'email'){
      setEmail(e.target.value);
    }
    else if (e.target.name === 'password'){
      setPassword(e.target.value);
    }
  }

  const handleAutoLogin = (e) => {
    setAutoLogin(!autoLogin);
  }

  return (
    <div id={styles.wrapper_login}>
      <div id={styles.wrapper_body}>
        <div className={styles.content}>
          <div className={styles.title}>
          <p style={{ fontFamily: 'ScDream', fontSize: '30px', cursor:'pointer' }} onClick={()=>{navigate('/')}}>무재달닷컴</p>
            <p style={{fontSize:'17px', marginBottom:'10px'}}>로그인하기</p> 
          </div>

          <form onSubmit={handleLogin}>
            <input className={formStyles.input} required type='email' placeholder='이메일' name='email' value={email || ''} onChange={handleChange}></input>
            <input className={formStyles.input} required type='password' placeholder='비밀번호' name='password' value={password || ''} onChange={handleChange}></input> 
            <label>로그인 유지<input type='checkbox' onChange={handleAutoLogin} checked={autoLogin}></input></label>
            <button className={formStyles.button} style={{marginTop:'10px'}} type='submit'><p>로그인</p></button>
          </form>       
          
          <div className={styles.nav}>
            <Link className={styles.nav_item} to='/register'>회원가입</Link>
            <Link className={styles.nav_item} to='/findPassword'>비밀번호 찾기</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login;